import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { expensesApi as eapi, formatCents } from '../../../api/expenses.js';

/**
 * Approvals queue: lists submitted reports and lets an approver approve them
 * inline. Requires the expense_report:approve verb (RBAC enforced server-side).
 */
export default function ApprovalsPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function load() {
    setLoading(true);
    try {
      const r = await eapi.listReports({ status: 'submitted' });
      setReports(r?.items || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load approvals');
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => { load(); }, []);

  async function approve(reportId) {
    setBusy(true);
    setError(null);
    try {
      await eapi.approveReport(reportId);
      await load();
    } catch (e) {
      setError(e.response?.data?.message || 'Approve failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section data-testid="expenses-approvals-page" data-loading={loading || busy ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Approvals</h1>
          <p className="muted">Submitted expense reports awaiting your approval.</p>
        </div>
      </header>

      {error && <div className="alert error" data-testid="expenses-approvals-error">{error}</div>}

      <div className="card">
        <table className="data-table" data-testid="expenses-approval-list">
          <thead><tr><th>Title</th><th>Status</th><th>Total</th><th></th></tr></thead>
          <tbody>
            {reports.map((r) => (
              <tr key={r.id} data-testid={`expenses-approval-row-${r.id}`}>
                <td><Link to={`/expenses/reports/${r.id}`}>{r.title}</Link></td>
                <td>{r.status}</td>
                <td>{formatCents(r.total_cents, r.currency)}</td>
                <td>
                  <button className="btn primary" data-testid={`expense-approve-${r.id}`} disabled={busy} onClick={() => approve(r.id)}>Approve</button>
                </td>
              </tr>
            ))}
            {!loading && reports.length === 0 && <tr><td colSpan={4} className="muted">Nothing awaiting approval.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
